/* 🤖 this file was generated by svg-to-ts */
export const mgcIconBoxFilled: {
  name: 'box-filled';
  data: string;
} = {
  name: 'box-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.162 3.044c-.098.019-.31.097-.472.174-.527.251-.598.347-2.055 2.782-.717 1.199-1.342 2.268-1.39 2.376-.236.538-.221.186-.235 5.684-.01 3.574 0 5.116.031 5.3.134.782.797 1.454 1.576 1.597.334.061 14.432.061 14.766 0 .768-.141 1.433-.806 1.574-1.574.059-.325.06-9.936 0-10.303-.086-.535-.204-.763-1.565-3.037-1.486-2.48-1.555-2.575-2.08-2.823a2.6 2.6 0 0 0-.507-.179c-.269-.051-9.384-.048-9.643.003M11 7v2H5.164l1.2-2 1.2-2H11zm6.636 0 1.2 2H13V5h3.436z"/></svg>`
};
